module.exports = __webpack_public_path__ + "static/media/step8.157c46fa.png";